const downloadFile = (file: Blob, fileName: string) => {
  const link = window.URL.createObjectURL(file);
  const anchorTag = document.createElement('a');
  anchorTag.setAttribute('href', link);
  let fn = `${fileName}`;
  const fileNameMap = fileName.split('.');

  if (
    file.type === 'application/octet-stream' &&
    !['csv'].includes(fileNameMap[fileNameMap.length - 1])
  ) {
    fn += '.doc';
  }
  anchorTag.setAttribute('download', fn);
  anchorTag.style.display = 'none';
  document.body.appendChild(anchorTag);
  anchorTag.click();
  document.body.removeChild(anchorTag);
};

export const downloadFileData = async (url: string, name: string) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to download file: ${response.statusText}`);
  }
  const blob = await response.blob();
  downloadFile(blob, name);
};

export const filePreviewData = async (fileUrl: string) => {
  const response = await fetch(fileUrl);
  if (!response.ok) {
    throw new Error(`Failed to load file: ${response.statusText}`);
  }
  return response.text();
};
